import {  } from '../functions.js';

export default class GtagEventElement extends HTMLElement {

    connectedCallback() {
        let eventName = this.dataset.event;
        let eventData = JSON.parse(this.dataset.data);

        window.gtag && window.gtag('event', eventName, eventData);
    }


}

customElements.define('gtag-event', GtagEventElement);
